/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  IterableTokenApiOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Mints a short-lived JWT that Iterable's Web SDK uses to authenticate the current provider for in-app messaging.
 */
export const getIterableToken = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<IterableTokenApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/iterable/token`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIterableTokenInfiniteQueryKey = () => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/iterable/token`
    ] as const;
    }

export const getGetIterableTokenQueryKey = () => {
    return [
    `https://providers-api.api.quick.md/api/v1/iterable/token`
    ] as const;
    }

    
export const getGetIterableTokenInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getIterableToken>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIterableTokenInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIterableToken>>> = ({ signal }) => getIterableToken(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIterableTokenInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getIterableToken>>>
export type GetIterableTokenInfiniteQueryError = void | ErrorApiOutContract


export function useGetIterableTokenInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIterableToken>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIterableToken>>,
          TError,
          Awaited<ReturnType<typeof getIterableToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIterableTokenInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIterableToken>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIterableToken>>,
          TError,
          Awaited<ReturnType<typeof getIterableToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIterableTokenInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIterableToken>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mints a short-lived JWT that Iterable's Web SDK uses to authenticate the current provider for in-app messaging.
 */

export function useGetIterableTokenInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIterableToken>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIterableTokenInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Mints a short-lived JWT that Iterable's Web SDK uses to authenticate the current provider for in-app messaging.
 */
export const prefetchGetIterableTokenInfiniteQuery = async <TData = Awaited<ReturnType<typeof getIterableToken>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetIterableTokenInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetIterableTokenQueryOptions = <TData = Awaited<ReturnType<typeof getIterableToken>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIterableTokenQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIterableToken>>> = ({ signal }) => getIterableToken(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIterableTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getIterableToken>>>
export type GetIterableTokenQueryError = void | ErrorApiOutContract


export function useGetIterableToken<TData = Awaited<ReturnType<typeof getIterableToken>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIterableToken>>,
          TError,
          Awaited<ReturnType<typeof getIterableToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIterableToken<TData = Awaited<ReturnType<typeof getIterableToken>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIterableToken>>,
          TError,
          Awaited<ReturnType<typeof getIterableToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIterableToken<TData = Awaited<ReturnType<typeof getIterableToken>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mints a short-lived JWT that Iterable's Web SDK uses to authenticate the current provider for in-app messaging.
 */

export function useGetIterableToken<TData = Awaited<ReturnType<typeof getIterableToken>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIterableTokenQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Mints a short-lived JWT that Iterable's Web SDK uses to authenticate the current provider for in-app messaging.
 */
export const prefetchGetIterableTokenQuery = async <TData = Awaited<ReturnType<typeof getIterableToken>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetIterableTokenQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetIterableTokenSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getIterableToken>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIterableTokenQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIterableToken>>> = ({ signal }) => getIterableToken(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIterableTokenSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getIterableToken>>>
export type GetIterableTokenSuspenseQueryError = void | ErrorApiOutContract


export function useGetIterableTokenSuspense<TData = Awaited<ReturnType<typeof getIterableToken>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIterableTokenSuspense<TData = Awaited<ReturnType<typeof getIterableToken>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIterableTokenSuspense<TData = Awaited<ReturnType<typeof getIterableToken>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mints a short-lived JWT that Iterable's Web SDK uses to authenticate the current provider for in-app messaging.
 */

export function useGetIterableTokenSuspense<TData = Awaited<ReturnType<typeof getIterableToken>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIterableTokenSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetIterableTokenSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getIterableToken>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIterableTokenInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIterableToken>>> = ({ signal }) => getIterableToken(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIterableTokenSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getIterableToken>>>
export type GetIterableTokenSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetIterableTokenSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIterableToken>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIterableTokenSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIterableToken>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIterableTokenSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIterableToken>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mints a short-lived JWT that Iterable's Web SDK uses to authenticate the current provider for in-app messaging.
 */

export function useGetIterableTokenSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIterableToken>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIterableToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIterableTokenSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




